export default __webpack_public_path__ + "static/compliance4-0e91fcbaafd056e9fbb7ca0f8e99a411.png";